import {
  Body2,
  Box,
  Color,
  Heading2,
  Icon,
  IconNames,
  Join,
  Space,
  Strong,
  useTheme,
} from '@gousto-internal/citrus-react';
import { useExperienceApiQuery } from '../../hooks/useExperienceApiQuery';

export function ProductFeaturesCard() {
  const {
    theme: {
      tokens: {
        typographyDefaults: { h4 },
      },
    },
  } = useTheme();

  const { data: marketingContent } = useExperienceApiQuery('/public/v1/marketing-content');
  const recipesAvailableThisWeek = marketingContent?.data?.recipesAvailableThisWeek ?? null;

  const cardStyles = {
    // This is not compliant with the design system
    boxShadow: `0px 4px 4px 0px rgba(0, 0, 0, 0.15)`,
  };

  const recipesRange = '2 to 5';

  return (
    <Box
      paddingH={3}
      paddingV={4}
      bg={Color.White}
      height="100%"
      style={cardStyles}
      data-testid="product-features-card"
    >
      <Join with={<Space size={3} />}>
        <Heading2 size={h4.size}>Key things about our menu</Heading2>
        <Feature icon="savings">
          <Body2>
            <Strong>Greater value</Strong> the more recipes you add
          </Body2>
        </Feature>
        <Feature icon="restaurant">
          <Body2>
            <Strong>
              {recipesAvailableThisWeek !== null
                ? `${recipesAvailableThisWeek} recipes`
                : 'Recipes'}
            </Strong>{' '}
            changing weekly
          </Body2>
        </Feature>
        <Feature icon="skip">
          <Body2>
            <Strong>Choose {recipesRange}</Strong> recipes or skip a box
          </Body2>
        </Feature>
        <Feature icon="dietary_preference">
          <Body2>
            <Strong>Meals for every appetite</Strong> and dietary need
          </Body2>
        </Feature>
      </Join>
    </Box>
  );
}

function Feature(props: { icon: IconNames; children: React.ReactNode }) {
  return (
    <Box display="flex">
      <Icon name={props.icon} />
      <Space size={3} direction="horizontal" />
      {props.children}
    </Box>
  );
}
